import { render, staticRenderFns } from "./step.vue?vue&type=template&id=1a858e78&"
import script from "./step.vue?vue&type=script&lang=js&"
export * from "./step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a858e78')) {
      api.createRecord('1a858e78', component.options)
    } else {
      api.reload('1a858e78', component.options)
    }
    module.hot.accept("./step.vue?vue&type=template&id=1a858e78&", function () {
      api.rerender('1a858e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps/step.vue"
export default component.exports